/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { Schema } from '@jalik/schema'

const UpdatePasswordFormSchema = new Schema({
  password: {
    type: 'string',
    required: true
  },
  password2: {
    type: 'string',
    required: true
  },
  requestId: {
    type: 'string',
    required: true
  },
  token: {
    type: 'string',
    required: true
  }
})

export default UpdatePasswordFormSchema
